import React from "react";

const VAT_RATE = 0.2;

const coupons = {
  // '7dollarsofffirstmonth': {
  //   discount: 700,
  //   type: 'amount_off',
  //   salesText: {
  //     'title': 'Get everything Wordtracker has to offer for a month for $10',
  //     'priceMark': <span className='price-mark price-mark-smaller'><span className='dollar-sign'>$</span>10<span className='only'>only</span></span>,
  //     'buttonBilling': 'Start my $10 trial',
  //     'buttonDetailsHint': <>Get Wordtracker for just <strong>$10 for a month</strong>, and only <strong>$17/month</strong> after that, forever.</>,
  //     'buttonHint': <>By signing up, you agree to our <a href='/terms' target='_blank'>terms</a>.<br/> After your first month trial, your regular price will be <strong>$17/month</strong>. You can cancel any time.</>,
  //   }
  // }
};

const plans = JSON.parse(`{"bronze_trial_plan":{"id":"price_1PpPoZ2NavrKZ6s0dxm76DqX","lookup_key":"bronze_trial_plan","plan_code":"price_1PpPoZ2NavrKZ6s0dxm76DqX","is_trial_plan":true,"name":"Wordtracker Bronze Subscription","tier":"bronze","period":"monthly","interval_count":1,"unit_amount_in_cents":1000},"bronze_monthly":{"id":"price_1Q5kNm2NavrKZ6s0od4LkYr1","lookup_key":"bronze_monthly","plan_code":"price_1Q5kNm2NavrKZ6s0od4LkYr1","is_trial_plan":false,"name":"Wordtracker Bronze Subscription","tier":"bronze","period":"monthly","interval_count":1,"unit_amount_in_cents":2400},"bronze_annual":{"id":"lannister_bronze_annual","lookup_key":"bronze_annual","plan_code":"lannister_bronze_annual","is_trial_plan":false,"name":"Wordtracker Bronze Subscription","tier":"bronze","period":"annual","interval_count":1,"unit_amount_in_cents":19500},"silver_trial_plan":{"id":"price_1PpPpI2NavrKZ6s08EHmUNHx","lookup_key":"silver_trial_plan","plan_code":"price_1PpPpI2NavrKZ6s08EHmUNHx","is_trial_plan":true,"name":"Wordtracker Silver Subscription","tier":"silver","period":"monthly","interval_count":1,"unit_amount_in_cents":1000},"silver_monthly":{"id":"lannister_silver_monthly","lookup_key":"silver_monthly","plan_code":"lannister_silver_monthly","is_trial_plan":false,"name":"Wordtracker Silver Subscription","tier":"silver","period":"monthly","interval_count":1,"unit_amount_in_cents":6900},"silver_annual":{"id":"lannister_silver_annual","lookup_key":"silver_annual","plan_code":"lannister_silver_annual","is_trial_plan":false,"name":"Wordtracker Silver Subscription","tier":"silver","period":"annual","interval_count":1,"unit_amount_in_cents":44900},"gold_trial_plan":{"id":"price_1PpPrj2NavrKZ6s0hVgx1eFi","lookup_key":"gold_trial_plan","plan_code":"price_1PpPrj2NavrKZ6s0hVgx1eFi","is_trial_plan":true,"name":"Wordtracker Gold Subscription","tier":"gold","period":"monthly","interval_count":1,"unit_amount_in_cents":1000},"gold_monthly":{"id":"lannister_gold_monthly","lookup_key":"gold_monthly","plan_code":"lannister_gold_monthly","is_trial_plan":false,"name":"Wordtracker Gold Subscription","tier":"gold","period":"monthly","interval_count":1,"unit_amount_in_cents":9900},"gold_annual":{"id":"lannister_gold_annual","lookup_key":"gold_annual","plan_code":"lannister_gold_annual","is_trial_plan":false,"name":"Wordtracker Gold Subscription","tier":"gold","period":"annual","interval_count":1,"unit_amount_in_cents":64000},"silver_annual_for_price_of_bronze":{"id":"price_1QXmxV2NavrKZ6s0m983e1AS","lookup_key":"silver_annual_for_price_of_bronze","plan_code":"price_1QXmxV2NavrKZ6s0m983e1AS","is_trial_plan":false,"name":"Wordtracker Silver Subscription","tier":"silver","period":"annual","interval_count":1,"unit_amount_in_cents":24000},"gold_annual_for_price_of_silver":{"id":"price_1QXmww2NavrKZ6s0zbBX32Uc","lookup_key":"gold_annual_for_price_of_silver","plan_code":"price_1QXmww2NavrKZ6s0zbBX32Uc","is_trial_plan":false,"name":"Wordtracker Gold Subscription","tier":"gold","period":"annual","interval_count":1,"unit_amount_in_cents":44900}}`);
const planLimits = JSON.parse(`{"bronze":{"results":1000,"domain_results":1000,"competitors":10,"ranking_lists":1,"ranking_keywords":1000,"countries":7,"segmentation":true,"api":false,"scout":false,"metrics":true,"trial":{"ranking_lists":1}},"gold":{"results":2000,"domain_results":2000,"competitors":50,"ranking_lists":10,"ranking_keywords":1000,"countries":-1,"segmentation":true,"api":99,"scout":true,"metrics":true,"trial":{"ranking_lists":1}},"hold":{"results":50,"domain_results":50,"competitors":5,"ranking_lists":1,"ranking_keywords":1000,"countries":7,"segmentation":true,"api":false,"scout":false,"metrics":true,"trial":{"ranking_lists":1},"disabled_features":["lists","ranking","unlimited_searches","bulk_search"]},"silver":{"results":1000,"domain_results":1000,"competitors":20,"ranking_lists":5,"ranking_keywords":1000,"countries":21,"segmentation":true,"api":false,"scout":true,"metrics":true,"trial":{"ranking_lists":1}}}`);

export const getNextPlanForLimits = (user, limit, requested) => {
  const userTier = getUserTier(user);
  const userPeriod = getUserPeriod(user);
  let nextTier = Object.values(tiers).find(tier => {
    const allowed = tier.limits[limit];
    if (requested <= allowed) {
      return true;
    }
    return false;
  });

  if (nextTier) {
    return `${nextTier.name}_${userPeriod}`;
  }

  return null;

}

export const getMonthlyForTier = tier => {
  return Object.values(plans).find(plan => plan.tier === tier && plan.period === 'monthly' && !plan.is_trial_plan);
}

export const getAnnualForTier = tier => {
  return Object.values(plans).find(plan => plan.tier === tier && plan.period === 'annual' && !plan.is_trial_plan);
}

export const getUserTier = user => {
  if (user.isFreeUser) return 'free';
  return user.subscription.tier;
}

const getUserPeriod = user => {
  if (user.isFreeUser) return null;
  return user.subscription.period;
}

let tiers = [ "bronze", "silver", "gold" ];

tiers = tiers.reduce((obj, tierName) => {
  const limits = planLimits[tierName];
  const { results, domain_results, competitors, ranking_lists, ranking_keywords, countries } = limits;
  const tier = { name: tierName };
  tier.limits = { results, domain_results, competitors, ranking_lists, ranking_keywords, countries }
  obj[tierName] = tier;
  return obj;
}, {});

const sales = {
  generic_plan: {
    states: {
      default: {
        title: 'Subscribe to Wordtracker',
        buttonDetails: 'Continue...',
        doneHtml: <p>
          A receipt has been emailed to you for your records.<br/>
          One moment while we log you in...
        </p>
      },
      expired_valid_card: {
        title: null,
        billingContent: plan => <div className='billing-content' style={{fontSize: '27px', marginTop: '39px'}}>
          <strong>Subscribe to Wordtracker</strong> for just ${plan.unit_amount_in_cents/100}/month.
          <div style={{marginBottom: '109px'}}></div>
        </div>,
        buttonBilling: 'Start my subscription',
        buttonHint: `(Payment will be taken and your account will be unlocked immediately. You can cancel at any time)`,
        doneHtml: <p>
          A receipt has been emailed to you for your records.<br/>
          One moment while we refresh your account status...
        </p>
      },
      expired_invalid_card: {
        title: null,
        billingContent: plan => <div className='billing-content' style={{fontSize: '27px', marginTop: '39px'}}>
          <strong>Subscribe to Wordtracker</strong> for just ${plan.unit_amount_in_cents/100}/month.
          <div style={{marginBottom: '109px'}}></div>
        </div>,
        buttonBilling: 'Start my subscription',
        buttonHint: `(Payment will be taken and your account will be unlocked immediately. You can cancel at any time)`,
        doneHtml: <p>
          A receipt has been emailed to you for your records.<br/>
          One moment while we refresh your account status...
        </p>
      },
      out_of_ranking_lists: {
        title: null,
        billingContent: plan => <div className='billing-content' style={{fontSize: '27px', marginTop: '39px'}}>
          <strong>Create up to {tiers[plan.tier].limits.ranking_lists} ranking lists</strong> by upgrading your subscription.
          <div style={{marginBottom: '69px'}}></div>
        </div>,
        buttonBilling: 'Upgrade now',
        buttonHint: subscription => `(Payment will be taken and your account will be updated immediately.${subscription.trial ? " Any remaining trial time will be refunded." : ""})`,
        doneHtml: <p>
          Upgrade complete!<br/>
          A receipt has been emailed to you for your records.<br/>
          One moment while we refresh your account status...
        </p>
      },
      curious_about_ranking_lists: {
        title: null,
        billingContent: plan => <div className='billing-content' style={{fontSize: '27px', marginTop: '39px'}}>
          <strong>Create up to {tiers[plan.tier].limits.ranking_lists} ranking lists</strong> by upgrading your subscription.
          <div style={{marginBottom: '69px'}}></div>
        </div>,
        buttonBilling: 'Upgrade now',
        buttonHint: subscription => `(Payment will be taken and your account will be updated immediately.${subscription.trial ? " Any remaining trial time will be refunded." : ""})`,
        doneHtml: <p>
          Upgrade complete!<br/>
          A receipt has been emailed to you for your records.<br/>
          One moment while we refresh your account status...
        </p>
      }
    }
  },
  bronze_trial_plan: {
    states: {
      default: {
        title: `Get everything Wordtracker has to offer for a month for $${plans.bronze_trial_plan.unit_amount_in_cents / 100}`,
        buttonDetails: 'Continue...',
        priceMark: <span className='price-mark price-mark-smaller'><span className='dollar-sign'>$</span>{plans.bronze_trial_plan.unit_amount_in_cents / 100}<span className='only'>only</span></span>,
        buttonBilling: `Start my $${(plans.bronze_trial_plan.unit_amount_in_cents / 100)} trial`,
        buttonDetailsHint: <>Get Wordtracker for just <strong>${plans.bronze_trial_plan.unit_amount_in_cents / 100} for a month</strong>, and only <strong>${plans.bronze_monthly.unit_amount_in_cents / 100}/month</strong> after that, forever.</>,
        buttonHint: <>By signing up, you agree to our <a href='/terms' target='_blank'>terms</a>.<br/> After your first month trial, your regular price will be <strong>${plans.bronze_trial_plan.unit_amount_in_cents / 100}/month</strong>. You can cancel any time.</>,
      }
    }
  }
}

const customBenefits = {
  bronze_trial_plan: [
    'Unlimited searches',
    'Up to 1000 results',
    'Analyze unlimited domains',
    'Track rank of up to 1000 keywords',
    'Full data exports'
  ]
}

export const getLimitsForTier = (tier) => tiers[tier].limits;

const buildBenefitsFromLimits = (name) => {
  const limits = tiers[name].limits;
  const benefits = [
    'Unlimited searches'
  ];
  Object.entries(limits).forEach(([key, value]) => {
    benefits.push(`${value} ${key}`);
  })
  return benefits;
}

export const getCoupon = id => {
  return coupons[id];
}

export const getBenefitsForPlan = plan => {
  if (customBenefits.hasOwnProperty(plan.id)) {
    return customBenefits[plan.id];
  }
  if (customBenefits.hasOwnProperty(plan.lookup_key)) {
    return customBenefits[plan.lookup_key];
  }
  return buildBenefitsFromLimits(plan.tier);
}

export const getSalesText = (priceId, state, couponId) => {
  let planSalesObj = sales.hasOwnProperty(priceId) ? sales[priceId] : sales.generic_plan;
  let salesTextObj = planSalesObj.states.default;

  const stateObj = planSalesObj.states[state];
  if (stateObj) {
    Object.entries(stateObj).forEach(([key, value]) => {
      salesTextObj[key] = value;
    })
  }
  const couponObj = coupons[couponId];
  if (couponObj) {
    Object.entries(couponObj.salesText).forEach(([key, value]) => {
      salesTextObj[key] = value;
    });
  }
  return salesTextObj;
}

export const getPlanByPriceId = id => {
  let price;
  price = plans[id];
  if (!price) {
    price = Object.values(plans).find(_price => _price.plan_code === id);
  }
  if (!price) throw `Plan with id ${id} not found.`;
  return price;
}